<div class="gung-table-skeleton-loader">
  <div class="d-flex flex-column align-items-start mb-4 gap-3">
    <div class="flex-shrink-0">
      <div class="placeholder-glow">
        <span class="placeholder rounded" style="width: 150px; height: 34px;"></span>
      </div>
    </div>
    <div class="w-100">
      <div class="placeholder-glow">
        <span class="placeholder rounded border" style="width: 100%; max-width: 500px; height: 35px;"></span>
      </div>
    </div>
  </div>
  <div class="table-responsive bg-white border rounded">
    <table class="table table-hover mb-0">
      <thead class="table-light">
        <tr>
          @for (col of columnArray; track $index) {
            <th class="border-bottom">
              <div class="placeholder-glow">
                <span class="placeholder col-7"></span>
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rowArray; track $index) {
          <tr>
            @for (col of columnArray; track $index) {
              <td>
                <div class="placeholder-glow">
                  <span class="placeholder col-8"></span>
                </div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
